/* =============================================================================
   CORE / PURCHASE-ORDERS — Bestellwesen (Phase E4b, S163)
   =============================================================================
   PURE Helfer für Bestellungen (purchase_orders/-items, Migration phase_122).
   Single-Source der Status-/Mengen-Logik (Spiegel der SQL-RPCs). Wareneingang läuft
   serverseitig über den E1-Ledger (stock_movements, source='order') — hier nur die
   reine Anzeige-/Vorschlags-Mathematik.
============================================================================ */

/** Bestellstatus-Stammdaten (Reihenfolge = Lebenszyklus). */
export const PO_STATUS = [
  { key: 'draft',              label: 'Entwurf',        color: '#9aa0a6' },
  { key: 'ordered',            label: 'Bestellt',       color: '#2f6b3a' },
  { key: 'partially_received', label: 'Teil-Lieferung', color: '#d9a227' },
  { key: 'received',           label: 'Erhalten',       color: '#2f6b3a' },
  { key: 'cancelled',          label: 'Storniert',      color: '#b94a48' }
];

export function poStatusLabel(status) {
  const s = PO_STATUS.find(x => x.key === status);
  return s ? s.label : (status || '—');
}
export function poStatusColor(status) {
  const s = PO_STATUS.find(x => x.key === status);
  return s ? s.color : '#9aa0a6';
}

/**
 * Vorschlagsmenge in EINKAUFSEINHEITEN für die Nachbestellung (Spiegel suggest_reorder):
 * ceil(Unterdeckung / Basiseinheiten-je-Einkaufseinheit). Keine Unterdeckung → 0;
 * fehlende/≤0-Umrechnung → null (nicht vorschlagbar).
 */
export function reorderUnits(minStock, stock, unitQtyBase) {
  const deficit = Number(minStock) - Number(stock);
  if (!(deficit > 0)) return 0;
  const uqb = Number(unitQtyBase);
  if (!(uqb > 0)) return null;
  return Math.ceil(deficit / uqb);
}

/**
 * PO-Status aus den Positionen ableiten (Spiegel der Status-Nachführung in receive_po_item):
 * alle Positionen voll empfangen → 'received'; irgendwas empfangen → 'partially_received';
 * sonst → 'ordered'. Leere Positionsliste → 'ordered'.
 * @param {Array<{qtyOrdered, qtyReceived}>} items
 */
export function receivedStatusFrom(items) {
  const arr = Array.isArray(items) ? items : [];
  if (!arr.length) return 'ordered';
  const full = arr.every(it => Number(it.qtyReceived) >= Number(it.qtyOrdered));
  if (full) return 'received';
  const any = arr.some(it => Number(it.qtyReceived) > 0);
  return any ? 'partially_received' : 'ordered';
}

/** Bestellmenge einer Position in Basiseinheiten (qty_ordered × unit_qty_base). */
export function lineBaseQty(qtyOrdered, unitQtyBase) {
  if (qtyOrdered == null || unitQtyBase == null) return null;
  const q = Number(qtyOrdered), u = Number(unitQtyBase);
  if (!isFinite(q) || !(u > 0)) return null;
  return q * u;
}

/** Bestellwert = Σ qty_ordered × price über die Positionen (fehlender Preis = 0). */
export function poTotalAmount(items) {
  return (Array.isArray(items) ? items : []).reduce((sum, it) => {
    const q = Number(it && it.qtyOrdered), p = Number(it && it.price);
    return sum + (isFinite(q) && isFinite(p) ? q * p : 0);
  }, 0);
}

/** Empfangsfortschritt in % = Σ qty_received / Σ qty_ordered × 100 (0, wenn nichts bestellt). */
export function receivedPct(items) {
  const arr = Array.isArray(items) ? items : [];
  let ordered = 0, received = 0;
  for (const it of arr) {
    ordered += Number(it && it.qtyOrdered) || 0;
    received += Number(it && it.qtyReceived) || 0;
  }
  if (!(ordered > 0)) return 0;
  return Math.round(received / ordered * 100);
}

/** Restmenge einer Position (qty_ordered − qty_received), nie < 0. */
export function outstandingQty(qtyOrdered, qtyReceived) {
  return Math.max(0, (Number(qtyOrdered) || 0) - (Number(qtyReceived) || 0));
}
